// ======================================================================
// File Name       : ArchivementListContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import moment from 'moment';
import { reduxForm, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import ArchivementSearch from '../../components/archivement/ArchivementSearch';
import ArchivementList from '../../components/archivement/ArchivementList';
import { searchUser } from '../../actions/archivement/ArchivementAction';
import { RETURN_MAX_NUM, SELECT_TARGET_DATA, DEFAULT_DATE_FORMAT_SERVER } from '../../constants/index';
import Header from '../../components/Header';
import MessageSearch from '../../components/MessageSearch';
import { SCORING_ARCHIVEMENT_LIST, SCORING_ARCHIVEMENT_DETAIL } from '../../constants/PathConstants';
import * as actionType from '../../constants/actionTypes/page';

class ArchivementListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterData: {
        loginId: '',
        userName: '',
        reportApprovalDateFrom: null,
        reportApprovalDateTo: null,
        userSortType: -1,
        ascendingDescendingSort: 0,
        startPosition: 0,
      },
      returnMaxNum: RETURN_MAX_NUM,
      isAllowShowSearchMessage: false,
    };

    this.onSearchData = this.onSearchData.bind(this);
    this.searchData = this.searchData.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.initData = this.initData.bind(this);
    this.createParams = this.createParams.bind(this);
    this.goToDetail = this.goToDetail.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  componentWillMount() {
    const { searchCondition } = this.props;
    const filterData = {
      ...this.state,
      filterData: searchCondition,
    };
    this.setState(
      filterData,
    );
    this.initData();
  }

  initData() {
    const { initialValues } = this.props;
    let column = null;
    let startPosition = 0;
    if (initialValues) {
      if (initialValues.userSortType) {
        column = initialValues.userSortType;
      }
      if (initialValues.startPosition) {
        startPosition = initialValues.startPosition;
      }
    }
    const param = this.createParams(false, initialValues, column, startPosition);
    this.props.dispatch(searchUser(param, false));
  }

  createParams(isCSV, data, column, startPosition) {
    const filterData = { ...data };
    if (!isNaN(parseInt(startPosition, 10))) {
      filterData.startPosition = startPosition;
    }
    if (column && Object.keys(column).length) {
      filterData.ascendingDescendingSort = column.sortState;
      filterData.userSortType = column.sortBy;
    }
    if (data && data.reportApprovalDateFrom) {
      filterData.reportApprovalDateFrom = moment(data.reportApprovalDateFrom).startOf('day').format(DEFAULT_DATE_FORMAT_SERVER);
    }
    if (data && data.reportApprovalDateTo) {
      filterData.reportApprovalDateTo = moment(data.reportApprovalDateTo).endOf('day').format(DEFAULT_DATE_FORMAT_SERVER);
    }
    if (!column) {
      filterData.ascendingDescendingSort = null;
      filterData.userSortType = null;
    }

    let selectTargetData = 0;
    if (isCSV) {
      selectTargetData = 1;
    }

    filterData.returnMaxNum = RETURN_MAX_NUM;
    const param = {
      selectTargetData,
      searchInfo: filterData,
    };

    return param;
  }

  goToDetail(userSecernId) {
    const { invalid, formValues } = this.props;
    if (!invalid) {
      this.props.dispatch({
        type: actionType.SAVE_SEARCH_CONDITION,
        parentPath: SCORING_ARCHIVEMENT_LIST,
        searchCondition: formValues,
      });
    }
    const path = SCORING_ARCHIVEMENT_DETAIL.replace(':id', userSecernId);
    this.props.history.push(path);
  }

  componentWillUnmount() {
    const { formValues } = this.props;
    this.props.dispatch({
      type: actionType.SAVE_SEARCH_CONDITION,
      parentPath: SCORING_ARCHIVEMENT_LIST,
      searchCondition: formValues,
    });
  }

  onSearchData() {
    const { dispatch, formValues, invalid } = this.props;
    if (invalid) {
      return;
    }
    const filterData = {
      loginId: formValues.loginId,
      userName: formValues.userName,
      reportApprovalDateFrom: formValues.reportApprovalDateFrom,
      reportApprovalDateTo: formValues.reportApprovalDateTo,
      startPosition: formValues.startPosition,
      userSortType: formValues.userSortType,
      ascendingDescendingSort: formValues.ascendingDescendingSort,
    };
    this.setState({ filterData }, () => {
      const paramSearch = this.createParams(false, filterData, null, 0);
      this.props.change('startPosition', 0);
      this.props.change('userSortType', null);
      this.props.change('ascendingDescendingSort', null);
      this.props.dispatch(searchUser(paramSearch, false))
      .then(() => {
        this.setState({ isAllowShowSearchMessage: true });
      });
    });
  }

  searchData(startPosition, column) {
    const { filterData } = this.state;
    const { invalid, dispatch, formValues } = this.props;
    if (invalid) {
      return;
    }
    const paramSearch = this.createParams(false, filterData, column, startPosition);
    this.props.dispatch(searchUser(paramSearch, false))
    .then(() => {
      this.setState({ isAllowShowSearchMessage: true });
    });
  }

  getStartEndData(startPosition) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let column = null;
    if (formValues.userSortType) {
      column = formValues.userSortType;
    }
    this.searchData(startPosition, column);
  }

  handleSortState(column) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let startPosition = 0;
    if (formValues.startPosition) {
      startPosition = formValues.startPosition;
    }
    this.searchData(startPosition, column);
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  render() {
    const { hoverIndex } = this.state;
    return (
      <div>
        <MessageSearch
          recordNum={this.props.recordNum}
          resultList={this.props.userList}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <ArchivementSearch
          onSearchBtnClick={this.onSearchData}
        />
        <ArchivementList
          userListInfo={this.props.userList}
          reportOperationCountInfo={this.props.reportOperationCountInfo}
          handleSortState={this.handleSortState}
          goToDetail={this.goToDetail}
          recordNum={this.props.recordNum ? this.props.recordNum : 0}
          startPosition={this.state.startPosition}
          getStartEndData={this.getStartEndData}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          hoverIndex={hoverIndex}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { archivement } = state;
  const { userList, recordNum, reportOperationCountInfo } = archivement;
  const { parentPath, searchCondition } = state.page;
  let initial = {};
  if (parentPath === SCORING_ARCHIVEMENT_LIST) {
    if (searchCondition) {
      initial = searchCondition;
    }
  }
  return {
    initialValues: initial,
    archivement,
    formValues: getFormValues('archivementList')(state),
    searchCondition,
    userList,
    recordNum,
    reportOperationCountInfo,
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'archivementList', // a unique identifier for this form
  touchOnChange: true,
})(ArchivementListContainer));
